import { Tkv2ReferenceViewModule } from '../../modules/referenceView/Tkv2ReferenceViewModule.tsx';

export const Tkv2PublicRecordSheetRouteElement = () => {
  return <Tkv2ReferenceViewModule isPopout dataSheet="public-record" />;
};
